import { NgModule, ErrorHandler } from '@angular/core';
import { IonicModule, IonicErrorHandler } from 'ionic-angular';
import { DynamicHTML } from './dynamic-html';

export { DynamicHTML } from './dynamic-html';

@NgModule({
    imports: [
        IonicModule
    ],
    declarations: [
        DynamicHTML
    ],
    exports: [
        DynamicHTML
    ],
    bootstrap: [],
    entryComponents: [
        
    ],
    providers: [{provide: ErrorHandler, useClass: IonicErrorHandler}]
})
export class DynamicHTMLModule{
    constructor(){
    }
}


// WEBPACK FOOTER //
// ./src/modules/dynamic-html/dynamic-html.module.ts